import { Task } from '../services/api';
import { formatContractSumDisplay } from './table';

const PERCENT_FORMAT = new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 0 });

export function sumTasksNumericField(tasks: Task[], field: keyof Task): number | null {
  let hasValue = false;
  let sum = 0;
  for (const row of tasks) {
    const raw = row[field];
    if (raw == null || raw === '') continue;
    const n = Number(raw);
    if (!Number.isNaN(n)) {
      sum += n;
      hasValue = true;
    }
  }
  return hasValue ? sum : null;
}

export function formatSharePercent(taskValue: number | null, contractValue: number | null): string {
  if (taskValue == null || contractValue == null || contractValue === 0) return '—';
  const pct = (taskValue / contractValue) * 100;
  return `${PERCENT_FORMAT.format(pct)}%`;
}

/** Финансовая ячейка: целое число с пробелами-разделителями, без символа валюты. */
export function formatFinanceCell(value: number | null): string {
  if (value == null) return '—';
  return formatContractSumDisplay(value);
}

export function formatSignedBalance(value: number): string {
  if (value > 0) {
    return `+${formatContractSumDisplay(value)}`;
  }
  return formatContractSumDisplay(value);
}
